import React from "react";
import "./ourServices.css";

export default function OurSolution() {
  const mountData = (Structure) => {
    localStorage.setItem("Mount", Structure);
  };
  return (
    <section id="OurSolution" className="ourSolutionSection">
      <div className="solutionHead">
        <h1>Our Solutions</h1>
        <p>
          Whether you're a solar contractor, installer, or homeowner, BH
          Electrical Services has the perfect solution to meet your needs and
          help you achieve your solar energy goals.
        </p>
      </div>
      <div className="solutionList">
        <div className="solutionCard">
          <img src="./images/sub/residential.jpg" alt="roofType"></img>
          <div className="cardContent">
            <h5>Residental Projects</h5>
          </div>
        </div>
        <div className="solutionCard" onClick={() => mountData("Comercial")}>
          <img src="./images/sub/commercial.jpg" alt="roofType"></img>
          <div className="cardContent">
            <h5>Commercial Projects</h5>
          </div>
        </div>
        <div className="solutionCard" onClick={() => mountData("Industrial")}>
          <img src="./images/sub/industrial.jpg" alt="roofType"></img>
          <div className="cardContent">
            <h5>Industrial Projects</h5>
          </div>
        </div>
      </div>
    </section>
  );
}
